/** @format */
import { SelectedFilters } from '@toucan/common/services/search/types';

import { Filter } from '@toucan/client/features/search/components/model-search-results/types';

export const getSelectedFiltersFromQueryString = (
    filter: Filter,
    selectedFilters: SelectedFilters
) => {
    const selectedValues = selectedFilters[filter.id];

    return filter.values.filter((value) => {
        if (Array.isArray(selectedValues)) {
            return selectedValues.includes(value.value.toString());
        }

        return selectedValues === value.value;
    });
};
